// import TextField from '@components/text-field/text-field';
import { Box, Chip, Grid, TextField, Typography } from "@mzc-pdc/ui";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { getAssetOwnersAPI } from "@modules/apis/assets";
import { useSelector } from "react-redux";
import { AutocompleteUsers } from "@components_v2/autocomplete";
import { useEffect } from "react";
import { StyledAutocompletePopper } from "@features/chip-popper-components/chip-types-input/chip-types-input.styled";
import { useTranslation } from "react-i18next";
import { ImageEmptySearchMini, ImageSearch } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";

export const ChipOwnersInput = ({
    user,
    disabled = false,
    onDeleteUser,
    onAddUser,
    placeholder = undefined,
    isEdit,
    isPopperComponent = false,
}) => {
    const { t } = useTranslation();
    const space = useSelector(({ stage }) => stage);
    const project = useSelector(({ project }) => project);
    const [open, setOpen] = useState(false);

    const [checkSearch, setCheckSearch] = useState(false); // Note : noOptionsText에서 검색 여부에 따라 내용이 달라져서 검색을 했는지 체크하기 위해 추가했습니다.
    const [value, setValue] = useState(user);
    const [searchedValue, setSearchedValue] = useState(""); //현재 검색중인 이름
    const [userData, setUserData] = useState({ nextToken: null, results: [] });
    const [pendingUser, setPendingUser] = useState(false);
    const USER_LIMIT = 20;

    const getUserList = useCallback(
        async (isInitValue = false) => {
            try {
                if (pendingUser || !value || (!isInitValue && !userData.nextToken)) return;
                setPendingUser(true);
                let params = {
                    limit: USER_LIMIT,
                };
                if (userData.nextToken) params.nextToken = userData.nextToken;

                const response = await getAssetOwnersAPI({
                    apiEndpoint: space.endpoint,
                    projectId: project.id,
                    params,
                });
                if (isInitValue) {
                    setUserData({ ...response.data });
                    setCheckSearch(true);
                } else
                    setUserData({
                        nextToken: response.data.nextToken,
                        results: [...userData.results, ...response.data.results],
                    });
            } catch (error) {
                console.error(error);
            } finally {
                setPendingUser(false);
            }
        },
        [pendingUser, space, value, searchedValue, userData, project],
    );

    const onHandleDeleteUser = useCallback(
        (index) => {
            onDeleteUser();
            setSearchedValue("");
            setCheckSearch(false);
        },
        [onDeleteUser],
    );

    const onHandleClickOption = useCallback(
        (selected) => {
            if (selected) {
                const foundUser = userData.results.find((user) => user.id === selected.id);
                setValue(foundUser);
                onAddUser({ id: foundUser?.id, name: foundUser?.name });
                setCheckSearch(false);
            } else {
                onDeleteUser();
            }
        },
        [userData, onAddUser],
    );

    const handleInputChange = (reason) => {
        if (reason === "clear") {
            // setSelectedUser(null);
            setValue(null);
        }
    };

    function PopperComponent(props) {
        const { disablePortal, anchorEl, open, ...other } = props;
        return <StyledAutocompletePopper {...other}></StyledAutocompletePopper>;
    }

    useEffect(() => {
        getUserList(true); //최초 조회
        if (user?.id) setValue(user);
    }, []);

    useEffect(() => {
        setValue(user);
    }, [user]);

    return (
        <AutocompleteUsers
            value={value?.id ? value : null}
            open={isPopperComponent ? true : open}
            setOpen={setOpen}
            disabled={disabled}
            setValue={setValue}
            isEdit={isEdit}
            placeholder={placeholder}
            options={userData.results?.map((user) => ({ name: user.name, id: user.id, email: user.email }))}
            checkDuplicateValue={false}
            onInputChange={handleInputChange}
            onDelete={onHandleDeleteUser}
            // onScroll={onHandleScrollUser} //TODO: 무한스크롤로 구현
            onClickOption={onHandleClickOption}
            PopperComponent={isPopperComponent ? PopperComponent : undefined}
            ListboxProps={isPopperComponent ? { sx: { maxHeight: "none" } } : undefined}
            isAvatarIconRequired={true}
            onFetchData={() => getUserList(false)}
            noOptionsText={
                !pendingUser && (
                    <Grid
                        container
                        justifyContent={"center"}
                        alignItems={`center`}
                        flexDirection={"column"}
                        sx={{ height: "97px" }}
                    >
                        {checkSearch ? (
                            <>
                                <ImageEmptySearchMini width={24} height={24} />
                                <Typography component={"span"} color={theme.palette.secondary[800]}>
                                    {t(`common::msg::No search results found.`)}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <ImageSearch width={24} height={24} />
                                <Typography component={"span"} color={theme.palette.secondary[800]}>
                                    {t(`common::msg::Search for the owner of the asset.`)}
                                </Typography>
                            </>
                        )}
                    </Grid>
                )
            }
            handleClose={() => setOpen(false)}
            sx={{
                ".MuiAutocomplete-endAdornment": { visibility: isPopperComponent ? "hidden" : "visible" },
            }}
        ></AutocompleteUsers>
    );
};
